import React from 'react';
import { Button, Input, Typography, Radio } from 'antd';
import { DownloadOutlined, PushpinOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';

const { Title } = Typography;

function EditTool(props) {
  const user = useSelector((state) => state.user);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <div
        style={{
          minWidth: '500px',
          padding: '2rem',
          border: '1px solid #ccc',
          boxShadow: '0 4px 5px #ccc',
          borderRadius: '5px',
        }}
      >
        <Title level={3}>짤 꾸미기</Title>
        <br />
        <Title level={5} style={{ textAlign: 'left' }}>
          문구
        </Title>
        <Input
          style={{ width: '100%' }}
          size='large'
          placeholder='짤에 추가할 문구를 입력하세요'
          onChange={props.onChange}
        />
        <br />
        <br />
        <Title level={5} style={{ textAlign: 'left' }}>
          크기
        </Title>
        <Radio.Group defaultValue='32px' onChange={props.onSize} size='large'>
          <Radio.Button value='16px'>작게</Radio.Button>
          <Radio.Button value='32px'>보통</Radio.Button>
          <Radio.Button value='48px'>크게</Radio.Button>
        </Radio.Group>
        <br />
        <br />
        <Title level={5} style={{ textAlign: 'left' }}>
          색깔
        </Title>
        <Radio.Group defaultValue='black' onChange={props.onColor} size='large'>
          <Radio.Button value='red'>빨강</Radio.Button>
          <Radio.Button value='green'>초록</Radio.Button>
          <Radio.Button value='black'>검정</Radio.Button>
          <Radio.Button value='blue'>파랑</Radio.Button>
          <Radio.Button value='yellow'>노랑</Radio.Button>
          <Radio.Button value='white'>흰색</Radio.Button>
        </Radio.Group>
        <Button
          type='primary'
          size='large'
          value='select'
          onClick={props.onPop}
        >
          선택
        </Button>
        <br />
      </div>
      <div
        style={{
          marginTop: '3rem',
        }}
      >
        <Button
          type='primary'
          shape='round'
          icon={<DownloadOutlined />}
          size='large'
          onClick={props.onDownload}
          style={{ marginRight: '1.5rem' }}
        >
          다운로드
        </Button>
        {user && user.isLogin ? (
          <Button
            type='primary'
            shape='round'
            icon={<PushpinOutlined />}
            size='large'
            onClick={props.onAdd}
          >
            내짤하기
          </Button>
        ) : (
          <Button
            type='primary'
            shape='round'
            size='large'
            onClick={() => {
              props.history.push('/login');
            }}
          >
            로그인해서 나만의 짤을 모아보자!
          </Button>
        )}
      </div>
    </div>
  );
}

export default withRouter(EditTool);
